import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

interface SidebarProps {
    collapsed?: boolean;
    isMobileMenuOpen?: boolean;
}

export const SidebarWrapper = styled.aside<SidebarProps>`
    position: relative;
    height: 100%;
    width: ${({ collapsed }) => (collapsed ? '80px' : '260px')};
    display: flex;
    flex-direction: column;
    transition: width 0.3s ease;
    background-color: #ffffff;
    justify-content: space-between;
    grid-row-start: 1;
    grid-row-end: 4;
    border-right: 1px solid #e0e0e0;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.03);

    @media (max-width: 768px) {
        position: absolute;
        left: 0;
        background: white;
        z-index: 100;
        width: 260px;
        transition: transform 0.3s ease-in-out;
        transform: translateX(${({ isMobileMenuOpen }) => (isMobileMenuOpen ? '0' : '-100%')});
        box-shadow: 2px 0 16px rgba(0, 0, 0, 0.1);
    }
`;

export const MenuLinkWrapper = styled.div<SidebarProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    flex: 1;
    width: 100%;
    justify-content: ${({ collapsed }) => (collapsed ? 'center' : 'flex-start')};
`;

export const SubMenu = styled.div`
    background: #fafafa;
    border-radius: 8px;
    margin: 8px 0;
    padding: 8px 0;
    width: 100%;
    display: none;
`;

export const SubMenuLink = styled(NavLink)`
    display: block;
    font-size: 13px;
    font-weight: 400;
    color: #666666;
    margin: 4px 0;
    padding: 8px 16px 8px 48px;
    transition: all 0.2s ease;
    border-radius: 6px;

    &:hover {
        color: #1a1a1a;
        background: #f7f7f7;
        font-weight: 500;
    }

    &.active {
        color: #1a1a1a;
        background: #f7f7f7;
        font-weight: 500;
    }
`;

export const IconArrowWrapper = styled.div`
    transition: transform 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const MenuLink = styled(NavLink)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.3;
    color: #666666;
    margin: 0;
    padding: 4px 12px;
    position: relative;
    transition: all 0.2s ease;
    border-radius: 0;
    text-decoration: none;

    &:hover {
        color: #1a1a1a;
        background: #fafafa;

        svg {
            color: #1a1a1a;
        }
    }

    &.active { 
        color: #1a1a1a;
        font-weight: 600; 
        padding-left: 9px;
        text-decoration: underline;
       
        ${SubMenu} {
            display: block;
        }

        ${IconArrowWrapper} {
            transform: rotate(90deg);
        }
    }
`;

export const MenuLinkText = styled.div<SidebarProps>`
    flex: 1;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    white-space: nowrap;
`;

export const MenuLinkIcoWrapper = styled.div<SidebarProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    flex-shrink: 0;

    svg {
        transition: color 0.2s ease;
    }
`;

export const SidebarLogoWrapper = styled.div`
    position: relative;
    padding: 0 20px;
    height: 71px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom:1px solid #e8e8e8;
    background: #ffffff;

    svg {
        max-height: 40px;
    }
`;

export const MenuItemsWrapper = styled.div`
    padding: 8px 10px;
    overflow-y: auto;
    flex: 1;

    /* Custom scrollbar */
    &::-webkit-scrollbar {
        width: 4px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: #e0e0e0;
        border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #000;
    }
`;

export const ButtonCollapse = styled.button`
    background: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 50%;
    position: absolute;
    right: -12px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);

    &:hover {
        background: #c18344;
        border-color: #c18344;
        transform: translateY(-50%) scale(1.1);

        svg {
            color: #ffffff;
        }
    }

    svg {
        color: #666666;
        transition: color 0.2s ease;
    }

    @media (max-width: 768px) {
        display: none;
    }
`;

export const ButtonStoreWrapper = styled.div`
    position: relative;
    padding: 16px;
    border-top: 1px solid #e0e0e0;
    background: #fafafa;
`;

export const ButtonStore = styled.button`
    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
    border: 1px solid #c18344;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    gap: 10px;
    color: #ffffff;
    letter-spacing: 0.3px;
    position: relative;
    width: 100%;
    height: 48px;
    padding: 0 16px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

    &:hover {
        background: linear-gradient(135deg, #000 0%, #f3f3f3 100%);
        border-color: #000;
        transform: translateY(-2px); 
    }

    &:active {
        transform: translateY(0);
    }

    svg {
        flex-shrink: 0;
    }
`;
